import { Component } from '@angular/core';
import { GOOGLE_REVIEWS_URL, TESTIMONIALS } from '../../data/landing-content';

@Component({
  selector: 'landing-inversores-testimonials',
  templateUrl: './landing-testimonials.component.html',
  styleUrls: ['./landing-testimonials.component.scss'],
})
export class LandingTestimonialsComponent {
  readonly testimonials = TESTIMONIALS;
  readonly googleReviewsUrl = GOOGLE_REVIEWS_URL;
  readonly stars = [1, 2, 3, 4, 5];
}
